import React, { useMemo } from 'react';
import { NetworkStateNewProps } from './types';
import { NetworkError } from './network-error/network-error';
import { NetworkUpdateLoaderProps } from './network-update-loader/types';
import { NetworkInitialLoader } from './network-initial-loader/network-initial-loader';
import { NetworkFilteredEmpty } from './network-filtered-empty/network-filtered-empty';
import { NetworkUpdateLoader } from './network-update-loader/network-update-loader';
import { NetworkEmpty } from './network-empty/network-empty';

export const NetworkStateNew: React.FC<NetworkStateNewProps> = ({
    size = 'l',
    isError,
    isLoading,
    isInitialized,
    isFiltered,
    hasData,
    initialLoaderProps,
    updateLoaderProps: updateLoaderExternalProps,
    errorProps,
    emptyFilteredProps,
    emptyProps,
    children,
    className,
}) => {
    const updateLoaderProps: NetworkUpdateLoaderProps = useMemo(() => {
        return {
            isLoading,
            ...updateLoaderExternalProps,
        };
    }, [isLoading, updateLoaderExternalProps]);

    if (isError) {
        return <NetworkError size={size} {...errorProps} className={className} updateLoader={updateLoaderProps} />;
    }

    if (isInitialized === false) {
        return <NetworkInitialLoader {...initialLoaderProps} className={className} />;
    }

    if (!hasData && isFiltered) {
        return (
            <NetworkFilteredEmpty
                size={size}
                {...emptyFilteredProps}
                className={className}
                updateLoader={updateLoaderProps}
            />
        );
    }

    if (!hasData) {
        return <NetworkEmpty size={size} {...emptyProps} className={className} updateLoader={updateLoaderProps} />;
    }

    // has data
    return (
        <>
            {children}
            <NetworkUpdateLoader className={className} {...updateLoaderProps} />
        </>
    );
};
